import React from 'react';
import { StackView, Typography } from '@telus-uds/components-base';
import PropTypes from 'prop-types';
import WebVideo from '../WebVideo/WebVideo';
import { VideoPropType, RefPropType } from './videoPropType';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const VideoPickerPlayer = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    video = {},
    videoPlayerRef,
    onStartVideo = () => {}
  } = _ref;
  return /*#__PURE__*/_jsxs(StackView, {
    space: 3,
    tokens: {
      flexShrink: 1
    },
    ref: ref,
    children: [/*#__PURE__*/_jsx("div", {
      ref: videoPlayerRef,
      children: video.videoId && /*#__PURE__*/_jsx(WebVideo, {
        ...video,
        onStart: () => onStartVideo(video)
      })
    }), /*#__PURE__*/_jsxs(StackView, {
      space: 2,
      children: [/*#__PURE__*/_jsx(Typography, {
        variant: {
          size: 'h3'
        },
        children: video.title
      }), /*#__PURE__*/_jsx(Typography, {
        variant: {
          colour: 'default'
        },
        children: video.description
      })]
    })]
  });
});
VideoPickerPlayer.displayName = 'VideoPickerPlayer';
VideoPickerPlayer.propTypes = {
  video: VideoPropType,
  videoPlayerRef: RefPropType,
  onStartVideo: PropTypes.func
};
export default VideoPickerPlayer;